module.exports = __webpack_public_path__ + "static/media/checkbox_gradiant.2455ca15.png";